import { render, staticRenderFns } from "./panoramaIndex.vue?vue&type=template&id=3540ee96&scoped=true"
import script from "./panoramaIndex.vue?vue&type=script&lang=js"
export * from "./panoramaIndex.vue?vue&type=script&lang=js"
import style0 from "./panoramaIndex.vue?vue&type=style&index=0&id=3540ee96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3540ee96",
  null
  
)

export default component.exports